import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { fetchStudentById, updateStudent } from '../reducers/StudentSlice';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

function EditStudent() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { student, status } = useSelector(state => state.students);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    studentName: '',
    fatherName: '',
    email: '',
    image: null,
    previewImage: '',
    gender: '',
    cnic: '',
    joinDate: '',
    city: '',
    contactNumber: '',
    currentAddress: '',
    permanentAddress: '',
    emergencyContact: '',
    department: '',
    currentYear: '',
    semester: '',
    bloodGroup: '',
  });

  useEffect(() => {
    if (id) {
      dispatch(fetchStudentById(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (student) {
      setFormData({
        studentName: student.studentName || '',
        fatherName: student.fatherName || '',
        email: student.email || '',
        gender: student.gender || '',
        cnic: student.cnic || '',
        joinDate: student.joinDate ? new Date(student.joinDate).toISOString().split('T')[0] : '',
        city: student.city || '',
        contactNumber: student.contactNumber || '',
        currentAddress: student.currentAddress || '',
        permanentAddress: student.permanentAddress || '',
        emergencyContact: student.emergencyContact || '',
        department: student.department || '',
        currentYear: student.currentYear || '',
        semester: student.semester || '',
        bloodGroup: student.bloodGroup || '',
        image: student.image || null,
        previewImage: student.image ? `/uploads/${student.image}` : '',
      });
    }
  }, [student]);

  const handleChange = (e) => {
    const { id, type, files, value } = e.target;

    if (type === 'file') {
      const file = files[0];
      if (file) {
        setFormData((prevState) => ({
          ...prevState,
          image: file,
          previewImage: URL.createObjectURL(file),
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const updatedStudentData = new FormData();
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== null && key !== 'previewImage') {
        updatedStudentData.append(key, formData[key]);
      }
    });

    try {
      const response = await dispatch(updateStudent({ id, studentData: updatedStudentData }));

      if (response) {
        toast.success('Customer has been updated!');
        navigate('/students');
      } else {
        toast.error('An error occurred while updating the student.');
      }
    } catch (error) {
      toast.error('Update failed!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container mt-1 text-white py-3">
        <h2 className="text-center mb-4">Edit Customer</h2>
        <form onSubmit={handleSubmit}>
          <div className="row g-3 mb-3">
            {[
              { id: 'studentName', label: 'Customer Name', type: 'text', placeholder: 'Enter Student Name' },
              { id: 'fatherName', label: 'Father Name', type: 'text', placeholder: 'Enter Father Name' },
              { id: 'email', label: 'Email', type: 'email', placeholder: 'Enter email' },
              { id: 'cnic', label: 'Student CNIC', type: 'text', placeholder: 'Enter CNIC' },
              { id: 'city', label: 'City', type: 'text', placeholder: 'Enter City' },
              { id: 'contactNumber', label: 'Contact Number', type: 'tel', placeholder: 'Enter Contact Number' },
              { id: 'currentAddress', label: 'Current Address', type: 'text', placeholder: 'Enter Current Address' },
              { id: 'permanentAddress', label: 'Permanent Address', type: 'text', placeholder: 'Enter Permanent Address' },
              { id: 'emergencyContact', label: 'Emergency Contact Number', type: 'tel', placeholder: 'Enter Emergency Contact Number' },
              { id: 'department', label: 'Department', type: 'text', placeholder: 'Enter Department' },
              { id: 'currentYear', label: 'Current Year', type: 'number', placeholder: 'Enter Current Year' },
              { id: 'semester', label: 'Semester', type: 'number', placeholder: 'Enter Semester' },
              { id: 'bloodGroup', label: 'Blood Group', type: 'text', placeholder: 'Enter Blood Group' },
            ].map(({ id, label, type, placeholder }) => (
              <div key={id} className="col-md-4">
                <label htmlFor={id} className="form-label">{label}</label>
                <input
                  type={type}
                  className="form-control"
                  id={id}
                  value={formData[id]}
                  onChange={handleChange}
                  placeholder={placeholder}
                />
              </div>
            ))}

            {/* Gender dropdown */}
            <div className="col-md-4">
              <label htmlFor="gender" className="form-label">Gender</label>
              <select
                className="form-select"
                id="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>

            {/* Join Date */}
            <div className="col-md-4">
              <label htmlFor="joinDate" className="form-label">Joining Date</label>
              <input
                type="date"
                className="form-control"
                id="joinDate"
                name="joinDate"
                onChange={handleChange}
                value={formData.joinDate}
              />
            </div>

            {/* Student Picture Upload */}
            <div className="col-md-4">
              <label htmlFor="image" className="form-label">Customer Picture</label>
              <input
                type="file"
                className="form-control"
                id="image"
                name="image"
                accept="image/*"
                onChange={handleChange}
              />
              {formData.previewImage && (
                <div className="mt-2">
                  <img
                    src={formData.previewImage}
                    alt="Student Preview"
                    className="img-thumbnail"
                    style={{ width: '150px', height: '150px' }}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="text-center d-flex justify-content-end">
            <button
              type="submit"
              className="btn btn-primary text-white"
              disabled={loading}
              style={{ width: '210px' }}
            >
              {loading ? (
                <span>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Updating...
                </span>
              ) : (
                'Update Customer'
              )}
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export default EditStudent